<template>
  <div
    :class="isMobile ? 'positioner' : 'nomobile-positioner'"
    :style="basicStyle"
  >
    <start-bar
      :fill-size="forcedSize > 0 ? forcedSize : Number(gamePhaseState.speedPower)"
      :glow="glow"
      :is-scaled="isScaled"
      :hide-default-mark="true"
    />
  </div>
</template>

<script lang="ts">
import { StartBar } from '@powerplay/core-minigames-ui'

import { defineComponent } from 'vue'
import { gamePhaseState } from '@/stores'

export default defineComponent({
  components: {
    StartBar
  },
  props: {
    isLeft: {
      type: Boolean,
      default: false
    },
    forcedSize: {
      type: Number,
      default: -1
    },
    glow: {
      type: Boolean,
      deafault: false
    },
    isScaled: {
      type: Boolean,
      default: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {

    return {
      gamePhaseState: gamePhaseState()
    }

  },
  computed: {
    basicStyle() {

      if (!this.isLeft) {

        return {
          'justify-content': 'flex-start'
        }

      }

      return {}

    }
  },
})

</script>
<style scoped lang="less">
.positioner {
    position: absolute;
    top: 0;
    left: 0;
    width: 85%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    pointer-events: none;
}
.nomobile-positioner {
    pointer-events: none;
    position: absolute;
    left: 5%;
    bottom: 5%;
    .power-start-bar {
        transform-origin: center bottom;
    }

}
</style>
